import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const FormsPage = lazy(() =>
  import('@/features/forms/components/FormsPage').then((m) => ({ default: m.FormsPage })),
);

export const formsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/forms',
  component: FormsPage,
});
